module.exports = __webpack_public_path__ + "img/default.370ac8e8.jpg";